import { EltType } from 'legacy/lut/classes/models/partner360/ELT/EltType'
import { isDocType } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/isDocType'
import {
  docStepTitles,
  stepTitles,
} from 'legacy/lut/components/widgets/public/partner360/ELT/models/PageTitles'

export const getSteps = (eltType: EltType) => {
  if (isDocType(eltType)) {
    return docStepTitles
  }
  return stepTitles
}
